import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";

import AppLayoutWrapFull from "components/AppLayoutWrapFull";
import Container from "components/Container/Container";
import Tabs from "components/Tabs/Tabs";

import FormElement from "components/FormElement/FormElement";
import Select from "components/Select/Select";

import TasksTab from "./components/TasksTab/TasksTab";

import PieChartBox from "./components/PieChartBox/PieChartBox";
import LineChartBox from "./components/LineChartBox/LineChartBox";
import LineChartBoxUser from "./components/LineChartBox/LineChartBoxUser";

import { loadStatsAction, loadUserStatsAction, loadStepsAction, loadDashboardTasksAction, loadSitesAction, loadUsersAction } from "store/actions/Actions";

import styles from "./Dashboard.module.scss";

const Dashboard = (props) => {
    // const [activeReg, setReg] = useState('HIPAA');
    const [activeTab, setActiveTab] = useState("ALL TASKS");
    const {entity, id} = props.match.params;

    const dispatch = useDispatch();
    const DatatableReducer = useSelector((state) => state.DatatableReducer);
    const activeReg = (DatatableReducer.datatable && DatatableReducer.datatable.dashboard && DatatableReducer.datatable.dashboard) ? DatatableReducer.datatable.dashboard.activeReg : 'HIPAA';

    const {
        UserStatsReducer,
        DashboardTasksReducer,
        loadDashboardTasksAction,
        SitesReducer,
        UsersReducer, 
        StatsReducer,
        loadUserStatsAction,
        loadSitesAction,
        loadStatsAction,
        UserOrgSiteReducer,
    } = props;

    const setTabAsActive = heading => () => {
        setActiveTab(heading);

        dispatch({
            type: 'SET_DASHBOARD_TAB',
            payload: {
                activeTab: heading,
            },
        });
    };

    // useEffect(() => {
    //     if (DatatableReducer.datatable && DatatableReducer.datatable.dashboard && DatatableReducer.datatable.dashboard.activeReg) {
    //         setReg(DatatableReducer.datatable.dashboard.activeReg);
    //     }
    // }, [DatatableReducer.datatable]);

    useEffect(() => {
        setActiveTab(DashboardTasksReducer.activeTab || 'ALL TASKS');
    }, [DashboardTasksReducer.activeTab, DashboardTasksReducer.tasks]);

    useEffect(() => {
        if (!StatsReducer.stats) {
            if (UserOrgSiteReducer.selected.is_admin) {
                loadStatsAction({ regulatory_act: activeReg });
            }
        }
        if (!UserStatsReducer.stats) {
            if (!UserOrgSiteReducer.selected.is_admin) {
                loadUserStatsAction({ regulatory_act: activeReg });
            }
        }
    }, [StatsReducer.stats, UserStatsReducer.stats, loadStatsAction, activeReg]);

    useEffect(() => {
        if (UserOrgSiteReducer.selected.is_admin) {
            loadStatsAction({ regulatory_act: activeReg });
        }
    }, [loadStatsAction, activeReg]);

    useEffect(() => {
        if (!UserOrgSiteReducer.selected.is_admin) {
            loadUserStatsAction({ regulatory_act: activeReg });
        }
    }, [loadUserStatsAction, activeReg]);

    useEffect(() => {
        if (!SitesReducer.sites) {
            loadSitesAction();
        }
    }, [SitesReducer.sites, loadSitesAction]);

    // useEffect(() => {
    //     if (!UsersReducer.users) {
    //         loadUsersAction();
    //     }
    // }, [UsersReducer.users, loadUsersAction]);

    useEffect(() => {
        if (SitesReducer.sites) {
            loadDashboardTasksAction();
        }
    }, [UsersReducer.users, SitesReducer.sites]);

    const tasks = DashboardTasksReducer.tasks || [];

    useEffect(() => {

        if (entity && entity === 'task' && tasks.length > 0){
            let openTask = tasks.find(task => task.id === id);
            if (openTask){
                props.history.push(`/dashboard/${openTask.subtype}/${id}/${openTask.first}`);
            }
        }
    }, [entity, tasks]);

    useEffect(() => {
        dispatch({
            type: 'SET_DATATABLE',
            payload: {
                datatable: {
                    dashboard: {
                        activeReg,
                    },
                },
            },
        });
    }, [activeReg]);

    const regDropdownRef = React.createRef();

    const filteredTasks = activeReg !== '' ? tasks.filter(task => task.regulatory_act === activeReg) : tasks;

    return (
        <AppLayoutWrapFull
            setActiveTab={setActiveTab}
        >
            {(StatsReducer.stats || UserStatsReducer.stats) && <>
                <div className={styles.overview}>
                <Container wide dashboard>

                    <div style={{ marginBottom: 30, width: 200, marginLeft: 'auto' }}>
                        <FormElement
                            // labelText="REGULATORY ACT"
                            htmlFor="regulatory_act"
                        >
                            <Select
                                size="md"
                                value={activeReg}
                                placeholder="All regulatory acts"
                                onClick={(e) => {
                                    // setReg(e.target.dataset.name || '')
                                    dispatch({
                                        type: 'SET_DATATABLE',
                                        payload: {
                                            datatable: {
                                                dashboard: {
                                                    activeReg: e.target.dataset.name || '',
                                                },
                                            },
                                        },
                                    });
                                }}
                                dropdownToggleRef={regDropdownRef}
                            >
                                <li key={`regid-all`} data-name={null}>All</li>
                                <li key={`regid-hipaa`} data-name={'HIPAA'}>HIPAA</li>
                                <li key={`regid-osha`} data-name={'OSHA'}>OSHA</li>
                            </Select>
                        </FormElement>

                    </div>

                    <div className={styles.boxes}>
                        {(UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_admin)
                            ? 
                            <>
                                <PieChartBox
                                    key="tasks"
                                    title="Total progress"
                                    desc="Number of tasks that are assigned and completed versus not completed"
                                    complete={StatsReducer.stats && StatsReducer.stats.tasks && StatsReducer.stats.tasks.complete}
                                    total={StatsReducer.stats && StatsReducer.stats.tasks && StatsReducer.stats.tasks.total}
                                    color="#21AAE1"
                                    bg="#C7E9F7"
                                    link={"/achieve/tasks?filter="}
                                />
                                <LineChartBox stats={StatsReducer.stats} />
                            </>
                            :
                            <>
                                <PieChartBox
                                    key="tasks"
                                    title="Total progress"
                                    desc="Number of tasks that are assigned and completed versus not completed"
                                    complete={UserStatsReducer.stats && UserStatsReducer.stats.all && UserStatsReducer.stats.all.complete}
                                    total={UserStatsReducer.stats && UserStatsReducer.stats.all && UserStatsReducer.stats.all.total}
                                    color="#21AAE1"
                                    bg="#C7E9F7"
                                />
                                <LineChartBoxUser stats={UserStatsReducer.stats} />
                        </>
                        }
                    </div>
                </Container>
            </div>
            <Tabs
                dashboard
                tabs={[
                    {
                        heading: `ALL TASKS`,
                        icon: "fal fa-list",
                        count: filteredTasks.length || '0',
                    },
                    {
                        heading: "TRAININGS",
                        icon: "fal fa-badge-check",
                        count: filteredTasks.filter(task => (task.type === 'training')).length || '0',
                    },
                    {
                        heading: "QUESTIONS",
                        icon: "fal fa-question-circle",
                        count: filteredTasks.filter(task => (task.type === 'question')).length || '0',
                    },
                    {
                        heading: "DOCUMENTS",
                        icon: "fal fa-file-alt",
                        count: filteredTasks.filter(task => (task.type === 'document')).length || '0',
                    },
                    {
                        heading: "MISC",
                        icon: "fal fa-user-cog",
                        count: filteredTasks.filter(task => (task.type === 'task')).length || '0',
                    },
                ]}
                setActiveTab={setTabAsActive}
                activeTab={activeTab}
                className={styles.tabs}
            >
                {/* Tab Content */}
                <Container wide dashboard>
                    {
                        {
                            "ALL TASKS": <TasksTab type="all" dataType="allTasksDash" tasks={filteredTasks} />,
                            "TRAININGS": <TasksTab type="training" dataType="trainingsDash" tasks={filteredTasks.filter(task => (task.type === 'training'))} />,
                            "QUESTIONS": <TasksTab type="question" dataType="questionsDash" tasks={filteredTasks.filter(task => (task.type === 'question'))} />,
                            "DOCUMENTS": <TasksTab type="document" dataType="documentsDash" tasks={filteredTasks.filter(task => (task.type === 'document'))} />,
                            "MISC": <TasksTab type="my" dataType="miscDash" tasks={filteredTasks.filter(task => (task.type === 'task'))} />,
                        }[activeTab]
                    }
                </Container>
            </Tabs>
            </>}
        </AppLayoutWrapFull>
    );
};

const mapStateToProps = (state) => ({
    SitesReducer: state.SitesReducer,
    UsersReducer: state.UsersReducer,
    StatsReducer: state.StatsReducer,
    DashboardTasksReducer: state.DashboardTasksReducer,
    UserStatsReducer: state.UserStatsReducer,
    UserOrgSiteReducer: state.UserOrgSiteReducer,
});

const mapDispatchToProps = {
    loadSitesAction,
    loadUsersAction,
    loadUserStatsAction,
    loadStatsAction,
    loadStepsAction,
    loadDashboardTasksAction,
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(Dashboard)
);
